import axios from '@/utils/api'

const actions = {
  async getSps ({commit}) {
    return axios({
      method: 'get',
      url: 'publico/praticas'
    })
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/portal/publico/praticasSustentaveis.js